
import { Box, Typography, Paper } from "@material-ui/core";
import TextInputEx from "components/_extensions/react-admin/input/TextInputEx";
import { useTranslate } from "react-admin";

export const NumberRangeFilterField = (props) => {
	const { label, source } = props;
	const translate = useTranslate();
	return (
		<Paper
			style={{ paddingLeft: 16, paddingRight: 16,  paddingTop: 4, paddingBottom: 4, maxWidth: 300, boxShadow: "0px 1px 4px rgba(0,0,0,0.2)" }}
		>
			<Typography variant="subtitle1" gutterBottom>
				{translate(label)}
			</Typography>
			<Box display="flex" flexDirection="row" justifyContent="space-between">
				<Box style={{ width: "48%" }}>
					<TextInputEx {...props} label="Min" source={`${source}.${source}:gte`} fullWidth margin="dense" type="number" />
				</Box>
				<Box style={{ width: "48%" }}>
					<TextInputEx {...props} label="Max" source={`${source}.${source}:lte`} fullWidth margin="dense" type="number" />
				</Box>
			</Box>
		</Paper>
	);
};
